import { createFilterActions } from "search-filter/hooks/useSearchFiltersFormActions";
const SearchFilterActionsProvider = {
  key: "searchFilters",
  provider: (formikContext) => createFilterActions(formikContext)
};
export default SearchFilterActionsProvider;
